import axios from "axios";
import env from "../variables/EndpointEnvironment";
const headers = {
  "Content-Language": localStorage.getItem('i18nextLng'),
}
const BestServiceAPI = (props) => {
  return axios.get(
    `${env.HOST}/layanan-terbaik-anda${props}`,
    {
      headers
    }
  );
};
export default BestServiceAPI;
